import sectionFaqGrid04Css from '../css-snippets/section-faq-grid-04';

const html = `
<style>${sectionFaqGrid04Css}</style>
<div
  data-container="faq-grid-container-fluid-unique-id"
  data-id="unique-id"
  data-attribute="faq-grid-container-fluid"
  data-top-padding="true"
  data-bottom-padding="true"
  class="faq-grid-container-fluid"
  data-container-full-width="true"
>
  <div data-attribute="faq-grid-container" class="faq-grid-container container">
    <div data-attribute="title-faq-grid" class="title-faq-grid">
      <h2>
        <strong>FAQ</strong>
      </h2>
    </div>
    <div data-attribute="list-item" class="list-item">
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            What is the UPRIGHT GO S?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            The new Upright GO S is the latest device from Upright, designed to
            make perfecting your posture more accessible and affordable than
            ever. Upright GO S is the simplest, fastest, and most natural way to
            improve your posture through advanced posture training technology
            derived from biofeedback and behavioral science. Strengthen back and
            core muscles, stimulate improved blood flow, and eliminate poor
            slouching habits once and for all.
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Is the UPRIGHT GO S waterproof?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            The Upright GO S is not waterproof and care should be takennot to
            let the USB-C port get wet. To ensure a secure fit, we recommend
            training with the GO S in a cool, dry environment as the adhesives
            don’t attach well to sweaty skin and may fall off.
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Are the adhesives reusable? How long does each one last?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            The adhesives can be used for multiple applications. Each one lasts
            up to 10 uses, depending on skin type and proper maintenance. For
            tips on how to get the most out of your adhesives, check out our
            Help Center
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            Where do you ship?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            We ship worldwide. Shipping to the US is free, and non-US customers
            are responsible for any custom fees that may be associated with the
            order once it arrives at the border.
          </div>
        </div>
      </div>
      <div data-attribute="item-wapper" class="item-wapper">
        <div data-attribute="item-question" class="item-question">
          <h3
            data-attribute="title-item-question"
            data-color="#000000"
            class="title-item-question"
          >
            What is the return policy?
          </h3>
          <span data-attribute="icon-minus" style="display: none">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </span>
          <span data-attribute="icon-plus">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
          </span>
        </div>
        <div data-attribute="item-answer" class="item-answer">
          <div data-attribute="answer-content" class="answer-content">
            Upright has a 30-day money-back guarantee. For more info on the
            return policy, visit https://www.uprightpose.com/return-policy/
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
